import isUndefined from 'lodash-es/isUndefined.js';
import { nextFrame } from '../../../lib/helpers.js';
import ChatModel from '../../chat/lib/chat.model.js';
import { StoreController } from '../../../lib/lit/store_controller.js';
import { computedChatsStore } from '../../chat/lib/chats.store.js';
import { store } from '../../chat/lib/chats.store.js';

/**
 * Chats are sorted by lastUpdatedAt field
 */

export class ChatListController extends StoreController {
  constructor(host) {
    super(host);
    this.atom = computedChatsStore;
    this.idealMaxRequests = 4;
  }

  async hostConnected() {
    super.hostConnected();
    await this.loadChats();
    this.activatePredefinedChat();
  }

  /** Activate chat by id and scroll to it */
  async activatePredefinedChat() {
    await nextFrame();

    // TODO: @MarkoZabcic check why is this here, we read activeChatId from store, and set it again? Check on full implementations (cspell:disable-line)
    ChatModel.setActive(this.activeChatId);
    await nextFrame();
    try {
      this.host.scrollToChatId(this.activeChatId);
    } catch (e) {
      // will be fine next time
    }
  }

  async loadChats() {
    this.host.loading = true;

    await this.loadChatsWithBaseAttributes({
      base: true,
      cache: true,
    });

    this.host.loading = false;

    this.calculatePerPageFrom(ChatModel.length);
    this.loadChatsWithAllAttributes({ page: 1 });
  }

  /**
   * Load only Chat with attributes chatId and createdAt
   *
   * Cache will assure that multiple requests will be called only once
   */

  async loadChatsWithAllAttributes({ page }) {
    const response = await this.loadChatsWithBaseAttributes({
      page,
      cache: true,
      perPage: this.perPage,
    });

    if (response.chats.length < this.perPage) return;
    this.loadChatsWithAllAttributes({ page: page + 1 });
  }

  loadChatsWithBaseAttributes(query = {}) {
    return ChatModel.loadChats(this.host.loadChatsUrl, query);
  }

  calculatePerPageFrom(total) {
    const wantedPerPage = Math.round(total / this.idealMaxRequests);
    const minPerPage = Math.max(10, wantedPerPage);
    this.perPage = Math.min(250, minPerPage);
  }

  shouldShowChat(chat) {
    const { kindFilter, titleFilter, muted } = this.host;

    // Never show blocked chats
    if (chat.isBlocked) return false;

    // Filter by isMuted
    if (!isUndefined(muted) && muted !== chat.isMuted) return false;

    // Filter by kind
    if (kindFilter && !kindFilter.includes(chat.kind)) return false;

    // Filter by title
    if (
      titleFilter &&
      !chat.title?.toLowerCase().includes(titleFilter.toLowerCase())
    ) {
      return false;
    }

    // All conditions are satisfied
    return true;
  }

  get chats() {
    return this.value.sortedChats;
  }

  get error() {
    return store.value.error;
  }

  // TODO: rename to filteredChats
  get sortedChats() {
    return this.chats.filter(c => this.shouldShowChat(c));
  }

  get activeChatId() {
    return store.value.activeChatId;
  }
}
